module.exports = __webpack_public_path__ + "static/media/JeremySaks.572a6ac1.jpg";